export default __webpack_public_path__ + "maps-examples-animate-image-layer-thumbnail-960-f643efa660ecd0bea822f7fa89c72643.webp";